import React from 'react'

// shared components
import Section from 'components/atoms/Section'
import SectionItem from 'components/atoms/SectionItem'

// local components
import Parent from './Parent'

const Parents = props => {
  const {
    title,
    account,
    subheaderText,
    buttonText,
    buttonRoute,
    reupRequired,
    setModal,
    editable
  } = props

  return (
    <Section
      title={title}
      subheaderText={subheaderText}
      buttonText={buttonText}
      buttonRoute={buttonRoute}
    >
      {account.parents.map(parent => (
        <SectionItem key={parent.id}>
          <Parent
            parent={parent}
            setModal={setModal}
            reupRequired={reupRequired}
            editable={editable}
          />
        </SectionItem>
      ))}
    </Section>
  )
}

export default Parents
